import m from "../../geodata/es2015/kosovoLow";
window.am4geodata_kosovoLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/kosovoLow.js
// module id = null
// module chunks = 